"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapsibleCard = void 0;
var framer_motion_1 = require("framer-motion");
var React = require("react");
var Icons_1 = require("../../_Core/Icons");
var IconButton_1 = require("../../Buttons/IconButton");
var Localization_1 = require("../../Localization");
var Stack_1 = require("../Stack");
var CollapsibleCard_styles_1 = require("./CollapsibleCard.styles");
var CollapsibleCard = function (_a) {
    var _b = _a.Height, Height = _b === void 0 ? "auto" : _b, Caption = _a.Caption, children = _a.children, HeaderContent = _a.HeaderContent, _c = _a.ButtonTitle, ButtonTitle = _c === void 0 ? Localization_1.strings.CollapsibleContainer_Label_ButtonTitle : _c, _d = _a.ButtonAriaLabel, ButtonAriaLabel = _d === void 0 ? Localization_1.strings.CollapsibleContainer_Label_ButtonAriaLabel : _d, SaveKey = _a.SaveKey, _e = _a.OnChange, OnChange = _e === void 0 ? function () { } : _e;
    var _f = React.useState(SaveKey ? JSON.parse(localStorage.getItem(SaveKey)) : false), collapsed = _f[0], setCollapsed = _f[1];
    var handleOnCollapsedClick = function () {
        OnChange(collapsed);
        if (SaveKey) {
            localStorage.setItem(SaveKey, JSON.stringify((!collapsed)));
        }
        setCollapsed(!collapsed);
    };
    var headerHeight = 55;
    var gap = 16;
    var panelHeight = Height !== "auto" ? Height - (headerHeight + gap) : "auto";
    return (React.createElement(CollapsibleCard_styles_1.Wrapper, null,
        React.createElement("div", { style: { minHeight: collapsed ? headerHeight : Height, display: "grid", gridGap: collapsed ? 0 : gap, gridTemplateRows: headerHeight + "px auto" } },
            React.createElement(Stack_1.HStack, { AutoColumns: "auto 1fr", Gap: "xSmall" },
                React.createElement("div", null,
                    React.createElement(framer_motion_1.motion.div, { animate: { rotate: collapsed ? -90 : 0 } },
                        React.createElement(IconButton_1.IconButton, { ButtonSize: "24px", IconSize: "24px", Title: ButtonTitle, AriaLabel: ButtonAriaLabel, OnClick: handleOnCollapsedClick, Icon: Icons_1.Icons.ChevronDown }))),
                React.createElement(Stack_1.HStack, { AutoColumns: "1fr auto" },
                    React.createElement(CollapsibleCard_styles_1.CaptionH4, null, Caption),
                    React.createElement("div", null, HeaderContent))),
            React.createElement(framer_motion_1.motion.div, { transition: { bounce: 0 }, animate: { opacity: collapsed ? 0 : 1, height: collapsed ? 0 : panelHeight } }, !collapsed && React.createElement("div", { style: { overflow: "hidden", height: panelHeight } }, children)))));
};
exports.CollapsibleCard = CollapsibleCard;
